import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card, ListGroup } from "react-bootstrap";

function EducationPage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Mit Sicherheit die Unterwasserwelt erleben.
                        Durch Ausbildung im Tauchverein.</Card.Header>
            <Card.Body>
                <Card.Text>
                    
                    <br />
                    Die Ausbildung und Brevetierung werden nach den Richtlinien des <a href="https://www.vdst.de" target="_blank" rel="noopener noreferrer">Verbands Deutscher Sporttaucher (VDST)</a> durchgeführt. Der VDST ist Mitglied in der CMAS, alle Tauchscheine sind international anerkannt. Wir vermitteln Theorie und Praxis individuell oder in Gruppen zu günstigen Kosten. Du lernst Gleichgesinnte kennen und genießt die Geselligkeit und die Unterstützung eines Vereins.
                    <br /><br />
                    Nähere Informationen zu den möglichen Tauchscheinen (Brevets) und Zusatzkursen findest du auf der Seite des VDST.
                    <br /><br />
                    Wenn Du zum Probetraining kommen möchtest, bringe bitte möglichst das <a href="/pdfs/Versicherungsschutz_vor_Vereinsaufnahme.pdf" target="_blank" rel="noopener noreferrer" download>Formular für den vorläufigen Versicherungsschutz</a> ausgefüllt mit.
                    <br /><br />
                    <strong>Das wird gemacht:</strong>
                    <ul>
                        <li>Theorie und Schwimmbadausbildung finden in Hennigsdorf statt</li>
                        <li>Bei unserer ehrenamtlichen Arbeit zur Tauchausbildung versuchen wir, auf die unterschiedlichen individuellen Ansprüche und Bedürfnisse einzugehen</li>
                        <li>Durch intensive Betreuung soll allen Teilnehmern an der Ausbildung ein erfolgreicher Abschluss ermöglicht werden</li>
                    </ul>
                    <br />
                    <strong>Das gehört dazu:</strong>
                    <ul>
                        <li>Für die Dauer der Ausbildung bzw. der Mitgliedschaft ist der Eintritt zur Schwimmhalle für die Trainingszeiten im Mitgliedsbeitrag enthalten</li>
                        <li>Leihausrüstung und eine Sportversicherung sind in den Lehrgangsgebühren</li>
                        <li>Die Ausbildung und die Lehrmaterialien des VDST bekommst du zum Selbstkostenpreis</li>
                        <li>Guten Rat für den Kauf von Tauchausrüstung und bei der Auswahl von Tauchreisen gibt es kostenlos</li>
                        <li>Die Mitgliedschaft im Tauchverein ist für mindestens ein Jahr notwendig. Danach entscheidest du, ob du als ordentliches Mitglied aufgenommen werden möchtest. Erst dann wird der Aufnahmebeitrag fällig.</li>
                        <li>Teilnahme am Schnuppertauchen ist für alle Interessenten nach Absprache möglich</li>
                    </ul>
                    <br />
                    <strong>Das solltet Ihr mitbringen:</strong>
                    <ul>
                        <li>Sicheres Beherrschen von 2 Schwimmarten (Brust- und Kraulschwimmen) sowie etwas sportliche Kondition</li>
                        <li>Liebe zur Bewegung im Wasser, keine Platzangst, allgemeine Gesundheit</li>
                        <li>Maske, Flossen und Schnorchel und natürlich auch Badebekleidung</li>
                        <li>Zeit und Lust für die Ausbildung und die Ausübung des Tauchsports</li>
                    </ul>
                </Card.Text>
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)
}

export default EducationPage;
